export default __webpack_public_path__ + "static/media/8c.3f0f9513.svg";